import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { Tabs } from '@components/common';
import { useLanguage } from '@contexts/LanguageContext';
import ExampleIcons from '@components/Icon/ExampleIcons/ExampleIcons';
import UserManagement from '@components/admin/UserManagement/UserManagement';
import './AdminPage.scss';

const AdminPage = () => {
    const { t } = useLanguage();
    const navigate = useNavigate();
    const location = useLocation();
    const [activeTab, setActiveTab] = useState('user-management');

    // Sync activeTab with current route
    useEffect(() => {
        if (location.pathname.includes('/user-management')) {
            setActiveTab('user-management');
        } else if (location.pathname.includes('/example-icons')) {
            setActiveTab('example-icons');
        } else if (location.pathname.includes('/push-notifications')) {
            setActiveTab('push-notifications');
        } else if (location.pathname === '/admin' || location.pathname === '/admin/') {
            // Default to user-management for base admin path
            setActiveTab('user-management');
        }
    }, [location.pathname]);

    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
        navigate(`/admin/${tabId}`);
    };

    const tabs = [
        {
            id: 'user-management',
            label: t('admin.user_management') || 'User Management',
            content: <UserManagement />
        },
        {
            id: 'example-icons',
            label: t('admin.example-icons') || 'Example Icons',
            content: <ExampleIcons />
        },

    ];

    return (
        <div className="admin-page">
            <div className="admin-header">
                <h1>{t('admin.title')}</h1>
                <p>{t('admin.subtitle')}</p>
            </div>

            <Tabs
                tabs={tabs}
                activeTab={activeTab}
                onTabChange={handleTabChange}
                size="medium"
            />

            {/* Keep the Routes for direct URL navigation */}


        </div>
    );
};

export default AdminPage;
